import { Component, OnInit } from '@angular/core';
import { PostnewJob } from '../../services/job-section.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from 'src/app/core/toast.service';
import { LoginService } from 'src/app/core/services/login.service';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { FeedDocumentComponent } from 'src/app/modules/feeds/pages/feed-document/feed-document.component';

@Component({
  selector: 'app-job-applicants',
  templateUrl: './job-applicants.component.html',
  styleUrls: ['./job-applicants.component.scss'],
})
export class JobApplicantsComponent implements OnInit {
  constructor(
    private jobService: PostnewJob,
    private spinner: NgxSpinnerService,
    private toast: ToastService,
    private loginService: LoginService,
    private activeRoute: ActivatedRoute,
    private _dialog: MatDialog
  ) { }

  limitApplicants = 5;
  offsetApplicants = 0;
  loadingApplicants = false;
  hasMoreApplicants = true;
  singleJob: any;
  applicantsList = [];
  applicantsTabCounts;
  selectedApplicantsStatus: string = 'ALL';
  jobIdInfo: any;
  loginDetails: any;

  selectedTabIndex: number = 0;
  selectedTabStatus: string = 'ALL';
  openAccordionId: string | null = null;
  openEnquiryAccordionId: string | null = null;
  newMessage: string = '';
  EditedMessageId: string = '';
  DisplayMessage: any[];
  enquiryMessage: any[];

  ngOnInit(): void {
    this.loginDetails = this.loginService.getLoginData();
    this.applicantsList = [];

    this.loadMyJob();

  }

  loadMyJob(): void {

    this.activeRoute.params.subscribe((params) => {
      this.jobIdInfo = params['id'];
      const status = params['status'];

      this.selectedTabIndex = status === 'APPLICANT' ? 0 : 6;
      this.selectedApplicantsStatus = status === 'APPLICANT' ? 'ALL' : 'ENQUIRY';


      this.jobService.getMyJobData(this.jobIdInfo).subscribe((res: any) => {

        this.singleJob = res;

      })

      this.refreshApplicants();
      this.getApplicantTabCounts(this.jobIdInfo);

    });
  }

  tabs = [
    { label: 'All', status: 'ALL', count: 0 },
    { label: 'Applied', status: 'APPLIED', count: 0 },
    { label: 'Shortlisted', status: 'SHORTLISTED', count: 0 },
    { label: 'Interviews', status: 'INTERVIEWS', count: 0 },
    { label: 'Accepted', status: 'ACCEPTED', count: 0 },
    { label: 'Declined', status: 'DECLINED', count: 0 },
    { label: 'Enquiry', status: 'ENQUIRY', count: 0 },
  ];

  onTabChange(event: any): void {
    this.selectedTabStatus = this.tabs[event.index].status;
    this.selectedApplicantsStatus = this.selectedTabStatus;
    this.openAccordionId = null;
    this.openEnquiryAccordionId = null;

    this.refreshApplicants();
  }

  refreshApplicants(): void {
    this.offsetApplicants = 0;
    this.hasMoreApplicants = true;
    this.applicantsList = [];
    this.fetchApplicants();
  }

  fetchApplicants() {

    if (this.loadingApplicants || !this.hasMoreApplicants) return;
    this.loadingApplicants = true;

    this.jobService
      .getFilteredApplicants(
        this.limitApplicants,
        this.offsetApplicants,
        this.selectedApplicantsStatus,
        this.jobIdInfo
      )
      .subscribe((res: any[]) => {

        if (res?.length) {
          this.applicantsList = [...this.applicantsList, ...res];
          this.offsetApplicants += this.limitApplicants;
        } else {
          this.hasMoreApplicants = false;
        }

        this.loadingApplicants = false;
        this.spinner.hide();
      });
  }

  getApplicantTabCounts(jobIdInfo: string) {

    this.jobService.getapplicantTabCounts(jobIdInfo).subscribe((res: any) => {
      this.applicantsTabCounts = {
        ALL: res?.data?.all?.aggregate?.count || 0,
        APPLIED: res?.data?.applied?.aggregate?.count || 0,
        SHORTLISTED: res?.data?.shortlisted?.aggregate?.count || 0,
        INTERVIEWS: res?.data?.interviews?.aggregate?.count || 0,
        ACCEPTED: res?.data?.accepted?.aggregate?.count || 0,
        DECLINED: res?.data?.declined?.aggregate?.count || 0,
      };
      this.updateApplicantTabsCount();
    });
  }

  updateApplicantTabsCount() {
    if (!this.applicantsTabCounts) return;
    this.tabs = this.tabs.map((tab) => ({
      ...tab,
      count: this.applicantsTabCounts[tab.status] || 0,
    }));
  }

  //  Update Applicant Status
  updateApplicantStatus(status: string, jobId: string) {
    this.jobService.updateJobApplicantStatus(jobId, status).subscribe({
      next: (res) => {
        this.getApplicantTabCounts(this.jobIdInfo);
        this.refreshApplicants();
        this.toast.openSnackBar(`Job ${status.toLowerCase()} successfully`);
      },
      error: (err) => {
        console.error('Failed to update job status:', err);
      },
    });
  }

  toggleAccordion(jobId: any): void {

    this.openEnquiryAccordionId = null;
    this.openAccordionId = this.openAccordionId === jobId.id ? null : jobId.id; // Toggle the accordion

    this.newMessage = ''; // Clear the input box
    this.DisplayMessage = [];

    if (jobId?.status) {
      this.getAllMessage(jobId?.id, jobId?.job_enquiries_find?.id);
    } else {
      this.getAllMessage(jobId?.job_applicants_find?.id, jobId?.id);
    }

  }

  // Enquiry
  EnquiryAcoordion(jobId: any): void {
    this.openAccordionId = null;

    this.openEnquiryAccordionId =
      this.openEnquiryAccordionId === jobId.id ? null : jobId.id;
    this.enquiryMessage = [];

    const jobID = jobId?.job_id;
    const userId = jobId?.status
      ? jobId?.dental_professional_id
      : jobId?.enquiry_userid;

    this.jobService.getApplicantEnquiry(jobID, userId).subscribe((data) => {
      this.enquiryMessage = data;
    });
  }

  getAllMessage(ApplicantId: any, EnquiryId: any) {

    this.jobService
      .getApplicantMessage(ApplicantId, EnquiryId)
      .subscribe((data) => {
        this.DisplayMessage = data;
      });
  }

  sendMessage(jobId: any): void {
    if (!this.newMessage.trim()) return; // Do not send empty messages

    const baseMessage = {
      message: this.newMessage,
      message_from: this.loginDetails.id,
    };

    const messages = jobId?.status
      ? { ...baseMessage, job_applicant_id: jobId.id }
      : { ...baseMessage, job_enquiry_id: jobId.id };

    this.jobService.addApplicantMessage(messages);

    this.newMessage = ''; // Clear the input box
  }

  deleteMessage(messageId: string): void {
    this.jobService
      .deleteApplicantMessage(messageId)
      .then(() => { })
      .catch((err) => {
        console.error('Error deleting message:', err);
      });
  }

  editMessage(message: any): void {
    this.newMessage = message.message;
    this.EditedMessageId = message.id;
  }

  UpdateMessage(editId: any): void {
    const UpdateMessage = {
      id: editId,
      message: this.newMessage,
    };

    this.jobService
      .editApplicantMessages(UpdateMessage.id, UpdateMessage.message)
      .then(() => {
        this.EditedMessageId = '';
        this.newMessage = '';
      });
  }

  feeddocumentView(doc: any) {
    if (doc) {
      this._dialog.open(FeedDocumentComponent, {
        width: '40%',
        panelClass: ['custom-modal'],
        data: doc,
      });
    }
  }

}
